import { createSelector } from 'reselect'

import { actionTypes } from 'actions/actionTypes'

import {
  numPersonsValues,
  numPortionsValuesRegularBox,
  numPortionsValuesLargeBox,
} from './boxPricesConfig'
import { State } from './boxPricesModels'

export const getError = (state: State) => state.error.get(actionTypes.MENU_BOX_PRICES_RECEIVE)

export const getMenuBoxPrices = (state: State) => state.menuBoxPrices

export const getMenuBoxPricesRecieve = (state: State) =>
  state.pending.get(actionTypes.MENU_BOX_PRICES_RECEIVE)

const BOX_TYPE = 'gourmet'

export const getNumPersonsToBoxDescriptors = createSelector(getMenuBoxPrices, (menuBoxPrices) => {
  if (!menuBoxPrices) {
    return null
  }

  const result = numPersonsValues
    .map((numPersons) => {
      const numPortionsValues =
        numPersons === '2' ? numPortionsValuesRegularBox : numPortionsValuesLargeBox

      const boxDescriptors = numPortionsValues.map((numPortionsStr) => ({
        num_portions: Number.parseInt(numPortionsStr, 10),
        price_per_portion: menuBoxPrices.getIn([
          numPersons,
          numPortionsStr,
          BOX_TYPE,
          'pricePerPortion',
        ]),
        price_per_portion_discounted: menuBoxPrices.getIn([
          numPersons,
          numPortionsStr,
          BOX_TYPE,
          'pricePerPortionDiscounted',
        ]),
        promo_code_valid: menuBoxPrices.getIn([
          numPersons,
          numPortionsStr,
          BOX_TYPE,
          'promoCodeValid',
        ]),
        total: menuBoxPrices.getIn([numPersons, numPortionsStr, BOX_TYPE, 'recipeTotal']),
        totalAfterDiscount: menuBoxPrices.getIn([numPersons, numPortionsStr, BOX_TYPE, 'total']),
      }))

      return [numPersons, boxDescriptors]
    })
    .reduce(
      (numPersonsToBoxDescriptors, [numPersons, boxDescriptors]) =>
        // Note: this reduce() can be replaced with Object.fromEntries() when the
        // CI runs on version of Node that supports it.
        ({
          ...numPersonsToBoxDescriptors,
          [numPersons as string]: boxDescriptors,
        }),
      {},
    )

  return result
})

export const getPricePerServing = createSelector(getMenuBoxPrices, (menuBoxPrices) => {
  if (!menuBoxPrices) {
    return null
  }

  return menuBoxPrices.getIn(['4', '4', 'gourmet', 'pricePerPortion'])
})
